import { useProfileStore } from '@stores/profile'

interface DisciplinePrivilegesReturn {
  canViewDisciplines: ComputedRef<boolean>
  canSimpleViewDisciplines: ComputedRef<boolean>
  canManageDisciplines: ComputedRef<boolean>
  canDeleteDisciplines: ComputedRef<boolean>
  canViewProgressReport: ComputedRef<boolean>
  canViewCustomers: ComputedRef<boolean>
  canManageBalances: ComputedRef<boolean>
  canManageTutorTasks: ComputedRef<boolean>
  canManageFiles: ComputedRef<boolean>
  canManageKanban: ComputedRef<boolean>
  canManageProgressReport: ComputedRef<boolean>
  canManageOrders: ComputedRef<boolean>
  canManageSubscriptions: ComputedRef<boolean>
}

export const useDisciplinePrivileges = (): DisciplinePrivilegesReturn => {
  const profileStore = useProfileStore()

  const hasPrivilege = (key: string): ComputedRef<boolean> =>
    computed<boolean>(() => profileStore.privileges?.includes(key) ?? false)

  return {
    canViewDisciplines: hasPrivilege('view-disciplines'),
    canSimpleViewDisciplines: hasPrivilege('simple-view-disciplines'),
    canManageDisciplines: hasPrivilege('manage-disciplines'),
    canDeleteDisciplines: hasPrivilege('delete-disciplines'),
    canViewProgressReport: hasPrivilege('view-progress-report'),
    canViewCustomers: hasPrivilege('view-customers'),
    canManageBalances: hasPrivilege('manage-balances'),
    canManageTutorTasks: hasPrivilege('manage-tutor-tasks'),
    canManageFiles: hasPrivilege('manage-files'),
    canManageKanban: hasPrivilege('manage-kanban'),
    canManageProgressReport: hasPrivilege('manage-progress-report'),
    canManageOrders: hasPrivilege('manage-orders'),
    canManageSubscriptions: hasPrivilege('manage-subscriptions'),
  }
}
